export const diagnostic = (state) => state.diagnostic //eslint-disable-line
export const showDiagnosticForm = (state) => state.showDiagnosticForm //eslint-disable-line
export const filteredParts = (state) => state.filteredParts //eslint-disable-line
